export default {
  'pages.feedback.status.withdrawn': '已撤回',
  'pages.layouts.userLayout.title': '你好！',
  'pages.getCaptchaSecondText': '秒後重新獲取',
  'pages.workbench.link': '歡迎使用',
  'pages.workbench.alertMessage': '更快更強的重型組件，已經發布。',
  'pages.404.subTitle': '抱歉，您訪問的頁面不存在。',
  'pages.404.buttonText': '返回首頁',
  'pages.admin.subPage.title': '這個頁面只有 admin 權限才能查看',
  'pages.admin.subPage.alertMessage':
    'umi ui 現已發佈，歡迎使用 npm run ui 啓動體驗。',
  'pages.searchTable.createForm.newRule': '新建規則',
  'pages.searchTable.updateForm.ruleConfig': '規則配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '規則名稱',
  'pages.searchTable.updateForm.ruleName.nameRules': '請輸入規則名稱！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '規則描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '請輸入至少五個字符',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    '請輸入至少五個字符的規則描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置規則屬性',
  'pages.searchTable.updateForm.object': '監控對象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '規則模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '規則類型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '設定調度週期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '開始時間',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '請選擇開始時間！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '規則名稱爲必填項',
  'pages.searchTable.titleCallNo': '服務調用次數',
  'pages.searchTable.titleStatus': '狀態',
  'pages.searchTable.nameStatus.default': '關閉',
  'pages.searchTable.nameStatus.running': '運行中',
  'pages.searchTable.nameStatus.online': '已上線',
  'pages.searchTable.nameStatus.abnormal': '異常',
  'pages.searchTable.titleUpdatedAt': '上次調度時間',
  'pages.searchTable.exception': '請輸入異常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '訂閱警報',
  'pages.searchTable.title': '查詢表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已選擇',
  'pages.searchTable.item': '項',
  'pages.searchTable.totalServiceCalls': '服務調用次數總計',
  'pages.searchTable.tenThousand': '萬',
  'pages.searchTable.batchDeletion': '批量刪除',
  'pages.searchTable.batchApproval': '批量審批',
  'pages.template.title': '模板示例',
  'pages.template.submit.success': '表單提交成功！',
  'pages.template.form.name': '姓名',
  'pages.template.form.email': '電子郵箱',
  'pages.template.form.department': '部門',
  'pages.template.form.joinDate': '入職日期',
  'pages.template.form.remarks': '備註',
  'pages.template.placeholder.name': '請輸入姓名',
  'pages.template.placeholder.email': '請輸入電子郵箱',
  'pages.template.placeholder.department': '請選擇部門',
  'pages.template.placeholder.remarks': '請輸入備註資訊',
  'pages.template.validation.nameRequired': '請輸入姓名',
  'pages.template.validation.emailRequired': '請輸入電子郵箱',
  'pages.template.validation.emailInvalid': '電子郵箱格式不正確',
  'pages.template.validation.departmentRequired': '請選擇部門',
  'pages.template.validation.joinDateRequired': '請選擇入職日期',
  'pages.template.department.tech': '技術部',
  'pages.template.department.sales': '銷售部',
  'pages.template.department.hr': '人力資源部',
  'pages.template.department.finance': '財務部',
  'pages.template.action.submit': '提交',
  'pages.template.action.reset': '重置',
};
